export default "<div class=\"wrapper app-queue__content app-queue__content--active\">\n    <h1>Upload</h1>\n    <uploader></uploader>\n</div>\n";